import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getTeamAlias, getTeamId, getTeamPermissions, getTeamRole, getResources, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    teamAlias: getTeamAlias(state, props),
  }),
  required: ["account", "teamAlias"],
  data: [{
    resource: "resources",
    url: () => {
      return {
        query: `{
          resources {
            id
            type
            alias
            name
            description
            updatedAt
            permissionLevel
          }
        }`,
      }
    },
  }, {
    resource: "teamPermissions",
    passthrough: true,
    url: ({ teamAlias }) => {
      return {
        id: `team-permissions-${teamAlias}`,
        query: `query ($teamId: IdOrAlias!) {
          team (id: $teamId) {
            name
            id
            role
            resourcePermissions {
              id
              type
              alias
              name
              description
              permissionLevel
              createdAt
              updatedAt
            }
          }
        }`,
        variables: {
          teamId: teamAlias,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    teamId: getTeamId(state, props),
    teamRole: getTeamRole(state, props),
    resources: getResources(state, props),
    permissions: getTeamPermissions(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
